import { useSelector } from 'react-redux';

import { useDeskId } from '@/hooks/useDeskId';
import { useIntegrations } from '@/hooks/useIntegrations';
import { useWhatsapp } from '@/hooks/useWhatsapp';
import { selectIntegrationId } from '@/redux/session/selectors';
import { WhatsAppIntegration } from '@/shared/types/integration';

import AdvancedCard from './AdvancedCard';
import CoexistenceCard from './CoexistenceCard';
import MessagingCard from './MessagingCard';
import StatusCard from './StatusCard';
import IntegrationConfigWrapper from '../Components/Integration';

const WhatsappSettings = () => {
  const integrationId = useSelector(selectIntegrationId);
  const deskId = useDeskId();
  const { integration } = useIntegrations<WhatsAppIntegration>(deskId, integrationId);

  const { onOAuthClick, isConnecting } = useWhatsapp();

  if (!integration) {
    return null;
  }

  const isCoexistence = integration.config?.is_coexistence;

  return (
    <IntegrationConfigWrapper
      integration={integration}
      selfGated={<AdvancedCard integration={integration} />}
    >
      <StatusCard
        integration={integration}
        onReauthorize={onOAuthClick}
        isConnecting={isConnecting}
      />
      <MessagingCard integration={integration} />
      {isCoexistence && <CoexistenceCard integration={integration} />}
    </IntegrationConfigWrapper>
  );
};

export default WhatsappSettings;
